import { Dispatch, SetStateAction } from 'react';
import { IronClub, TourBagIronDetail } from '@/api/models';
import Checkbox from '@/common/Checkbox';
import Modal from '@/common/Modal';
import { createEmptyTourBagIronDetail } from '@/utils';
import { HeadTypeName } from '@/constants';
import styles from './AddIronsModal.module.scss';

interface IAddIronsModal {
  ironClubsData: IronClub[];
  ironClubs: TourBagIronDetail[];
  setIronClubs: Dispatch<SetStateAction<TourBagIronDetail[]>>;
  showAddIronsModal: boolean;
  closeAddIronsModal: () => void;
  headTypeName?: HeadTypeName;
}

function AddIronsModal({ ironClubsData, ironClubs, setIronClubs, showAddIronsModal, closeAddIronsModal, headTypeName = 'Iron' }: IAddIronsModal) {
  const setClubs = ironClubs.map((club) => club.ironClubName);
  const ironClubsDataMap = ironClubsData.reduce<Record<number, IronClub>>((acc, curr) => {
    acc[curr.ironClubId] = curr;
    return acc;
  }, {});

  const handleClubType = (club: IronClub) => {
    const exists = setClubs.includes(club.name);
    if (exists) {
      const updatedIrons = [...ironClubs].filter((iron) => iron.ironClubName !== club.name).sort((a, b) => (ironClubsDataMap[a.ironClubId].sortId || 0) - (ironClubsDataMap[b.ironClubId].sortId || 0));
      setIronClubs(updatedIrons);
    } else {
      const newIron: TourBagIronDetail = createEmptyTourBagIronDetail({ ironClubId: club.ironClubId, ironClubName: club.name, headTypeName });
      const updatedIrons = [...ironClubs, newIron].sort((a, b) => (ironClubsDataMap[a.ironClubId].sortId || 0) - (ironClubsDataMap[b.ironClubId].sortId || 0));
      setIronClubs(updatedIrons);
    }
  };

  return (
    <Modal isOpen={showAddIronsModal} onClose={closeAddIronsModal}>
      <div className={styles.container}>
        <div className={styles.title}>Add Club to Set</div>
        {ironClubsData.map((club) => (
          <Checkbox key={club.ironClubId} label={club.name} checked={setClubs.includes(club.name)} onClick={() => handleClubType(club)} className={styles.checkbox} />
        ))}
        <button onClick={closeAddIronsModal} className={styles.close}>
          Close
        </button>
      </div>
    </Modal>
  );
}

export default AddIronsModal;
